// Paid plan tiers — placeholder pricing, edit here (used by /plans page, Product JSON-LD and prerender).
export const PLANS_PAGE = {
  path: "/plans",
  title: "Plans & Pricing — Human-Verified Trip Plans",
  description:
    "Choose a WanderlyMe plan: the free AI planner, a Verified Plan with every venue, hour and price checked by a human in 48 hours, or a Concierge Plan with bookings research and revisions. Prices in AUD.",
  h1: "Plans & pricing",
  intro: "The AI planner is free. When a trip really matters, add a human who checks every line before you book.",
};

export const PLANS = [
  {
    id: "verified",
    name: "Verified Plan",
    price_aud: 149,
    tagline: "A human checks every venue, hour and price in your itinerary.",
    delivery: "Delivered within 48 hours",
    inclusions: [
      "Every hotel, restaurant and attraction checked by hand against current listings",
      "Opening hours confirmed for your exact travel dates, including holidays",
      "Prices and booking links re-checked, with cheaper or better-located swaps where found",
      "Written summary of what changed and why, emailed and saved to your account",
    ],
  },
  {
    id: "concierge",
    name: "Concierge Plan",
    price_aud: 349,
    tagline: "Everything in Verified, plus bookings research and two revision rounds.",
    delivery: "Delivered within 48 hours",
    inclusions: [
      "Everything in the Verified Plan",
      "Bookings research: best-value options for stays, tickets and transfers with direct links",
      "Two revision rounds after delivery as your plans firm up",
      "Links to the official government sources for visa, entry and safety requirements for your nationality",
    ],
  },
];
